import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';
import { DocumentNode } from 'graphql';
import { GraphQLSubscribe } from '../utils/methods/graphql.subscribe';

@Injectable()
export class CreateActiveElementSubscription extends GraphQLSubscribe {
	override command: DocumentNode = gql`
		subscription OnCreateActiveElement {
			onCreateActiveElement {
				id
				terminalId
				stationNumber
				element
			}
		}
	`;
}
